<template>
  <div class="position-relative d-flex align-items-center justify-center">
    <v-tooltip
      right
      max-width="300px"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          color="primary"
          outlined
          fab
          small
          class="border border-nitro d-flex align-items-center justify-center"
          :class="{
            'bg-transparent border border-white' : $store.state.module.view_dark,
          }"
          v-on="on"
          @click="showModal = true"
        >
          <img
            class="mt-1"
            :src="`/images/bt_report_${$store.state.module.view_dark ? 'white': 'color'}.png`"
            width="25px"
          >
        </v-btn>
      </template>
      <span>Reportar problema no conteúdo</span>
    </v-tooltip>
    <v-dialog
      v-model="showModal"
      :overlay-opacity="1"
      :width="$vuetify.breakpoint.smAndUp ? '600px' : '100%'"
    >
      <v-card>
        <v-card-title class="border-bottom border-bold border-nitro">
          <v-row>
            <v-col cols="11">
              <p class="mr-2 d">
                Relatar um problema encontrado em
                <span class="text-italic">
                  {{ content ? content.title : 'Videocast' }}
                </span>
              </p>
            </v-col>
            <v-col cols="1">
              <BtnClose @click="showModal = false" />
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="px-4">
          <v-row>
            <v-col :cols="12">
              <p class="text-gray mb-0">
                O canal Reportar problema é específico para problemas relacionados a problemas de conteúdo. Problemas relacionados a tecnologia ou falha no acesso devem ser reportados diretamente à coordenação da escola.
              </p>
            </v-col>
            <v-col :cols="12">
              <v-select
                v-model="form.device"
                :items="devices"
                label="Dispositivo"
              />
            </v-col>
            <v-col
              v-if="form.device == 'Outro'"
              :cols="12"
            >
              <v-text-field
                v-model="form.customDevice"
                :counter="10"
                label="Nome do dispositivo"
                required
              />
            </v-col>
            <v-col :cols="12">
              <v-textarea
                v-model="form.message"
                :value="form.message"
                color="primary"
                counter
                label="Mensagem"
                prepend-inner-icon="fa-solid fa-comment-dots"
                :rules="rules"
              />
            </v-col>
            <v-col>
              <input
                ref="imageInput"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                class="d-none"
                @change="onChangeFile"
              >
              <v-btn
                color="primary"
                @click="$refs.imageInput.click()"
              >
                Imagem
                <v-icon
                  right
                  dark
                >
                  fa fa-image
                </v-icon>
              </v-btn>
              <p
                v-if="form.file"
                class="text-lowercase text-body-2"
              >
                {{ form.file.name }}
              </p>
            </v-col>
            <v-col :cols="12">
              <v-btn
                color="primary"
                class="font-weight-bold px-4 white--text"
                rounded
                :disabled="disabled"
                @click="storeTicket"
              >
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BtnClose from "@/common/components/BtnClose.vue";

export default {
  name: 'TicketCreate',
  components:{
    BtnClose,
  },
  data() {
    return {
      showModal: false,
      form: {
        message: '',
        device: '',
        file: null,
        customDevice: '',
      },
      devices: [
        'Desktop (computador)',
        'Notebook',
        'iPad',
        'Tablet Android',
        'iPhone',
        'Smartphone Android',
        'Outro'
      ]
    }
  },
  computed: {
    ...mapGetters(['authUser','content','module']),
    rules(){
      return [
        (value) => value.length > 10 || 'insira ao menos 10 caracteres',
      ]
    },
    device(){
      return this.form.device != 'Outro' ?  this.form.device : `${this.form.customDevice} (${this.form.device})`
    },
    disabled(){
      return this.form.message.length < 10 || !this.form.file || !(this.form.device != 'Outro' ? this.form.device.length : this.form.customDevice )
    }
  },
  methods: {
    onChangeFile(e){

      const files = e.target.files

      if(files && !['image/png','image/jpeg','image/jpg','image/gif'].includes(files[0].type)){
        console.log(files[0].type)
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: 'O arquivo selecionado deve ser uma imagem'
        });
        return ;
      }

      if(files) {
        this.form.file = files ? files[0] : null;
      }
    },
    ...mapActions(['isLoading']),
    async storeTicket() {

      this.isLoading();
      const message = `
      ${this.form.message}
      [*]
        Módulo: ${this.module.name},
        Posicão:${this.content ? this.content.order+1 : 'Videocast'},
        ${this.content && this.content.type == 'quiz' ? `Quantidade de Questões: ${this.content.content.length}`: ''},
      `
      const form = new FormData;

      form.append('message', message)
      form.append('device', this.device)
      form.append('file', this.form.file)
      form.append('ticketable_id', !this.content || this.content.type == 'quiz'  ? this.module.id : this.content.ticketable_id)
      form.append('ticketable_type', this.content ? this.content.type : 'videocast')

      axios.post('/api/v1/ticket', form , { headers: { "Content-Type": `multipart/form-data`,}})
      .then(()=> {
        this.message = '';
        this.file = '';
        this.showModal = false;
        this.$notify({
          type: 'success',
          title: 'Sucesso',
          text: 'Mensagem enviada com sucesso!'
        });
      })
      .catch((e) => {
        const {response : { data : { errors : { message : messages }}}} = e;
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: messages[0] ?? 'Ocorreu um erro ao enviar a mensagem'
        });
        })
      .finally(() => {
        this.isLoading(false);
      })

    }
  }
}
</script>
<style lang="css" scoped>
  .text-gray {
    color: #767676 !important;
  }
</style>